import styled from 'styled-components';

export const DOCUMENT_PREVIEW_MAX_WIDTH = '345px';
export const DOCUMENT_PREVIEW_MAX_HEIGHT = '466px';

interface Props {
  $isFixedSize?: boolean;
}

export const DocumentPreviewImage = styled.img<Props>`
  max-width: ${({ $isFixedSize }) => ($isFixedSize ? DOCUMENT_PREVIEW_MAX_WIDTH : '100%')};
  max-height: ${({ $isFixedSize }) => ($isFixedSize ? DOCUMENT_PREVIEW_MAX_HEIGHT : '100%')};
  border: ${({ $isFixedSize, theme }) => ($isFixedSize ? `1px solid ${theme.colors.border1}` : 'none')};
  border-radius: ${({ $isFixedSize, theme }) => ($isFixedSize ? '0' : theme.rounds.container2Round)};
`;
